import React from 'react'
import Heading from 'components/shared/Heading'
import './index.scss'

const EstateHeader = ({streetAddress, customerRef, invisoRef, segment}) => {
  return (
    <div className="estate-header">
      <div className="address">
        {segment && (
          <img
            className="segment"
            src={segment.iconUrl}
            alt={segment.name}
            style={{backgroundColor: segment.backgroundColor}}
          />
        )}
        <Heading level={2}>{streetAddress}</Heading>
      </div>
      <div className="references">
        {customerRef && (
          <span><span>Meglers oppdragsnr.:</span>{customerRef} - </span>
        )}
        {invisoRef && (
          <span><span>EFKT ref.:</span>{invisoRef}</span>
        )}
      </div>
    </div>
  )
}

export default EstateHeader
